import { render, staticRenderFns } from "./AccountBase.vue?vue&type=template&id=9f72a912&scoped=true"
import script from "./AccountBase.vue?vue&type=script&lang=js"
export * from "./AccountBase.vue?vue&type=script&lang=js"
import style0 from "./AccountBase.vue?vue&type=style&index=0&id=9f72a912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f72a912",
  null
  
)

export default component.exports